export default {
  getMenuCollapse(state) {
    return state.isCollapse;
  },
  getBreadcrumbItems(state) {
    return state.breadcrumbItems;
  },
};
